import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSort = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.67383 9H14.3262C14.9253 9 15.2253 8.36135 14.8017 7.98785L10.4755 4.17365C10.2129 3.94212 9.78708 3.94212 9.52448 4.17365L5.19831 7.98785C4.77468 8.36135 5.07471 9 5.67383 9ZM5.30481 11.0723C5.41398 11.0126 5.53938 10.9889 5.66289 11.0048H14.3371C14.4606 10.9889 14.586 11.0126 14.6952 11.0723C14.8044 11.1321 14.8917 11.2248 14.9445 11.3373C14.9973 11.4497 15.013 11.5759 14.9892 11.6978C14.9653 11.8196 14.9033 11.9308 14.812 12.0152L10.4767 15.827C10.3432 15.9388 10.1744 16 10 16C9.82563 16 9.65683 15.9388 9.52325 15.827L5.18802 12.0152C5.09671 11.9308 5.03467 11.8196 5.01085 11.6978C4.98703 11.5759 5.00266 11.4497 5.0555 11.3373C5.10834 11.2248 5.19564 11.1321 5.30481 11.0723Z",
		fill: "#0D2976"
	})
});
export default SvgSort;
